import { env } from '@gitbook/env';

const GB_TEST_FLAGS_SESSION_STORAGE_KEY = 'gitbook_test_flags';

/**
 * Return feature flag overrides from sessionStorage.
 *
 * This is for testing purposes and is only active in the test environment.
 * It allows to set feature flags in e2e tests.
 *
 * When flags are passed to the login function they are persisted to sessionStorage
 * so they survive client-side routing that may strip query params.
 * Flags must be set in each test as tests run in different browser contexts, so flags set in one test won't leak to another test.
 */
export function getFeatureFlagTestOverrides(): string[] | undefined {
    if (env !== 'test') {
        return undefined;
    }

    const raw = new URLSearchParams(window.location.search).get('flags');
    if (raw) {
        const flags = raw.split(',').filter(Boolean);
        try {
            sessionStorage.setItem(GB_TEST_FLAGS_SESSION_STORAGE_KEY, JSON.stringify(flags));
        } catch {
            // Ignore sessionStorage errors
        }
        return flags;
    }

    // Fallback to sessionStorage if the URL param was stripped by routing.
    try {
        const stored = sessionStorage.getItem(GB_TEST_FLAGS_SESSION_STORAGE_KEY);
        if (stored) {
            return JSON.parse(stored);
        }
    } catch {
        // Ignore sessionStorage errors
    }

    return undefined;
}
